<!--
 * @FileDescription: 已发货商品列表
 * @Author: 陈文景
 * @Date: 2022-12-10 15:18:19
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div class="content">
    <p class="goods-info">
      <span>{{ `Logistics Information (${defaultTips(data.packId)})` }}</span>
      <span class="status">{{ defaultTips(data.packStatus) }}</span>
    </p>

    <div class="search">
      <el-checkbox :value="checkAll" :indeterminate="isIndeterminate" :disabled="!filter.length" @change="handleSelectAll">Select All</el-checkbox>
      <BatchSearchOne @clear="handleClearBatchSearchOne" @search="handleSearchBatchSearchOne" />
    </div>

    <div>
      <template v-for="item in data.items">
        <SkuInfoItemOne v-if="filter.includes(item.skuCode)" :key="item.id" :data="item" @amount="changeCheckedOrQuantity" />
      </template>

      <!-- 空状态 -->
      <template v-if="!filter.length">
        <div class="not-data">
          <img src="~@/assets/img/undraw_random_thoughts_re_cob6.svg" alt="img.svg" />
          <span class="tips-text">No Record</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import SkuInfoItemOne from '@/components/SkuInfoItemOne.vue'
import BatchSearchOne from '@/components/BatchSearchOne.vue'

export default {
  props: {
    // 商品数据
    data: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  components: {
    SkuInfoItemOne,
    BatchSearchOne
  },
  data() {
    return {
      filter: this.data.items.map((item) => item.skuCode),
      checkAll: false, // 是否全选
      isIndeterminate: false // 全选按钮的半选中状态
    }
  },
  watch: {
    'data.items': {
      handler(value) {
        let flag = value.every((item) => item.check === true)
        if (flag) {
          this.checkAll = true
          this.isIndeterminate = false
        } else {
          this.checkAll = false
          if (value.every((item) => item.check === false)) {
            this.isIndeterminate = false
          } else {
            this.isIndeterminate = true
          }
        }
      },
      deep: true
    }
  },
  computed: {
    defaultTips() {
      return (value) => value || '-'
    }
  },
  methods: {
    /**
     * 选择所有
     */
    handleSelectAll(value) {
      this.checkAll = value
      this.isIndeterminate = false
      this.$emit('change', value, 1, this.data.packId)
    },

    /**
     * 批量搜索清除内容的回调事件
     */
    handleClearBatchSearchOne() {
      this.filter = this.data.items.map((item) => item.skuCode)
    },

    /**
     * 批量搜索的回调事件
     *
     * @param {String} value 搜索关键字
     */
    handleSearchBatchSearchOne(value) {
      let skus = value && value.split(',')
      if (skus && skus.length) {
        let result = []
        this.data.items.forEach((item) => {
          if (skus.includes(item.skuCode)) {
            result.push(item.skuCode)
          }
        })
        this.filter = result
      }
    },

    /**
     * 某项复选框被选中或数量发生改变时的事件
     */
    changeCheckedOrQuantity() {
      this.$emit('amount')
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  margin-top: 5px;
  padding: 15px;
  background-color: #fff;
  &:first-child {
    margin-top: 0;
  }
  .goods-info {
    font-size: 16px;
    font-weight: 500;
  }
  .goods-info {
    .status {
      color: #cdd4dd;
      font-size: 12px;
      margin-left: 10px;
    }
  }
  .search {
    display: flex;
    height: 36px;
    margin: 10px 0;
    align-items: center;
    justify-content: space-between;
  }
  .not-data {
    display: flex;
    height: 100%;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    img {
      width: 268px;
      object-fit: cover;
    }
    .tips-text {
      color: #747a87;
      font-size: 14px;
      margin-top: 18px;
    }
  }
}
</style>
